import { connect } from "react-redux"

import { addToCart, forcePanelIndex } from "areas/product/store/actions"

export default function withActions(WrappedComponent) {
  const InternalProductActions = (props) => {
    return <WrappedComponent {...props} />
  }

  const mapStateToProps = (state, ownProps) => {
    return {
      choices: state.choices,
      isAddingToCart: state.wizardUI.isAddingToCart,
      wizardData: state.wizard.data,
    }
  }

  const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      addToCart: (e) => {
        e.preventDefault()
        dispatch(addToCart())
      },
      forcePanelIndex: (idx) => {
        dispatch(forcePanelIndex(idx))
      },
    }
  }

  const ProductActions = connect(
    mapStateToProps,
    mapDispatchToProps
  )(InternalProductActions)

  return ProductActions
}
